var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-box',{style:({ width: _vm.width }),attrs:{"data":_vm.brandOptions,"nonI18nConvert":true},on:{"click":_vm.checkSelectedMall},model:{value:(_vm.brandNo),callback:function ($$v) {_vm.brandNo=$$v},expression:"brandNo"}})}
var staticRenderFns = []

export { render, staticRenderFns }